import { Image, Container, Row, Col } from 'react-bootstrap';
import "./Services.css";
import "./IndustriesRedesign.css";

import Banner from "../Img/Industries/Industries Banner.jpg";
import W1 from "../Img/Industries/Network.jpg";
import W2 from "../Img/Industries/Cost.jpg";
import W3 from "../Img/Industries/Expertise.png";
import W4 from "../Img/Industries/Time Saving.jpg";
import W5 from "../Img/Industries/Solutions.jpg";
import W6 from "../Img/Industries/Communications.jpg";
import W7 from "../Img/Industries/Professional Approach.jpg";

// Industry images
import AutomobilesImg    from "../Img/Industries/Automobiles.jpg";
import ECommerceImg      from "../Img/Industries/ECommerce.jpg";
import PharmaceuticalsImg from "../Img/Industries/Pharmaceuticals.jpg";
import FoodImg           from "../Img/Industries/Food.jpg";
import FreightImg        from "../Img/Industries/Freight.jpg";
import FashionImg        from "../Img/Industries/Fashion.jpg";
import ChemicalsImg      from "../Img/Industries/Chemicals.jpg";

const INDUSTRIES = [
  {
    image: AutomobilesImg,
    title: "Automobiles",
    text: "Don't you think it will be great for your business to have a reliable partner handling all your automobile logistics needs? As we have experts who take care of equipment, component and aftermarket supply chain, we analyse your supply chain, suggest optimal warehouse management solutions and help you save on cost and time.",
  },
  {
    image: ECommerceImg,
    title: "E-Commerce",
    text: "In the e-commerce business, speed is of the essence. We know what it takes to delight your customers and our e-commerce modal services are designed to help you efficiently manage your supply chain, even in times of increased demand like festivals and sales.",
  },
  {
    image: PharmaceuticalsImg,
    title: "Pharmaceuticals",
    text: "The basic principle of modern logistics is saving time in favor of the supply for the pharmaceutical industries. The timely supply of pharmaceutical products helps meet the ever-growing demand and does not allow for lack of basic pharmaceuticals and consumables.",
  },
  {
    image: FoodImg,
    title: "Food",
    text: "Keeping in mind how the food industry is dependent on timely and seamless supply of material, there is absolutely no room for error in the supply chain. With our world-class warehousing facilities that are also integrated with cold chain storage, we help you optimise your food business supply chain.",
  },
  {
    image: FreightImg,
    title: "High Efficiency Freight & Commercial Transport",
    text: "Wherever your cargo is going, and whatever it is, we can offer you the ideal blend of reliability, security and rapidity. We offer a range of transit times and flexible route options integrated with a full range of additional services at origin and destination.",
  },
  {
    image: FashionImg,
    title: "Fashion & Retail",
    text: "As a specialised modal services and supply chain solutions provider for the fashion and retail industry, we perfectly understand its seasonality and consequently the need for a strong, scalable infrastructure.",
  },
  {
    image: ChemicalsImg,
    title: "Chemicals",
    text: "Maintaining high levels of safety and security standards, we have a driven approach towards the chemical industry, applying international standards of quality and service.",
  },
];

function Industries() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Banner} height={500} width="100%" fluid />

      <Container>
        <Row>
          <Col>
            <h1 className='text-center my-4 text-decoration-underline'><strong>Industries</strong></h1>
            <p style={{ fontSize: '20px' }} className='text-center'>
              MMOPL serves clients across diverse industries — Automobiles, E-Commerce, Pharmaceuticals,
              Food, Fashion &amp; Retail, Chemicals and High-Efficiency Freight &amp; Commercial Transport —
              delivering reliable, cost-effective and efficient global logistics solutions.
            </p>
          </Col>
        </Row>
      </Container>

      {/* ====== MODERN IMAGE-CARD INDUSTRIES SECTION ====== */}
      <section className="industries-section">
        <div className="industries-header">
          <span className="industries-eyebrow">What We Serve</span>
          <h2 className="industries-title">Industries We Empower</h2>
          <p className="industries-subtitle">
            From automobiles to chemicals — MMOPL delivers end-to-end logistics solutions
            engineered for each industry's unique rhythm, regulations and realities.
          </p>
        </div>

        <div className="industries-grid">
          {INDUSTRIES.map((item, i) => (
            <article className="industry-card" key={i}>
              <div
                className="industry-card__bg"
                style={{ backgroundImage: `url(${item.image})` }}
              />
              <div className="industry-card__overlay" />
              <span className="industry-number">{String(i + 1).padStart(2, "0")}</span>
              <div className="industry-card__content">
                <h3 className="industry-title">{item.title}</h3>
                <p className="industry-desc">{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* ====== EXISTING BENEFITS SECTIONS (unchanged) ====== */}
      <Container className="mt-5">
        <Row className="d-flex justify-content-center">
          <Col md={6} className="p-5 justify-text">
            <h1 className="mb-4"><strong>EXTENSIVE NETWORK</strong></h1>
            <p style={{ fontSize: '20px' }}>Our freight forwarding company has built an extensive network of reliable and trusted carriers, agents, and logistics partners worldwide. This strong global network enables us to provide seamless transportation solutions, competitive freight rates, and dependable delivery services that meet our clients' shipping and supply chain requirements.</p>
          </Col>
          <Col md={6} className="p-5 justify-text">
            <Image src={W1} alt="Network" width="100%" />
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="d-flex justify-content-center">
          <Col md={6} className="p-5 justify-text">
            <Image src={W2} alt="Cost" width="100%" />
          </Col>
          <Col md={6} className="p-5 justify-text">
            <h1 className="mb-4"><strong>COST-EFFECTIVENESS</strong></h1>
            <p style={{ fontSize: '20px' }}>We leverage our strong network of global carriers, agents, and logistics partners — along with our industry expertise and negotiation capabilities — to secure the most competitive freight rates and optimal routing options for our clients. This ensures cost-effective shipping solutions, improved transit efficiency, and greater overall value compared to managing logistics independently.</p>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="d-flex justify-content-center">
          <Col md={6} className="p-5 justify-text">
            <h1 className="mb-4"><strong>OUR EXPERTISE</strong></h1>
            <p style={{ fontSize: '20px' }}>Our team possesses in-depth expertise in international freight forwarding and global supply chain management, including comprehensive knowledge of shipping regulations, customs procedures, documentation requirements, and multimodal transportation solutions.</p>
          </Col>
          <Col md={6} className="p-5 justify-text">
            <Image src={W3} alt="Expertise" width="100%" />
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="d-flex justify-content-center">
          <Col md={6} className="p-5 justify-text">
            <Image src={W4} alt="Time" width="100%" />
          </Col>
          <Col md={6} className="p-5 justify-text">
            <h1 className="mb-4"><strong>TIME-SAVING</strong></h1>
            <p style={{ fontSize: '20px' }}>Managing international shipping and logistics can be complex and time-consuming, often diverting attention from core business activities. Our team handles the entire freight forwarding process from start to finish — allowing our clients to save time, reduce operational burdens, and focus on growing their business.</p>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="d-flex justify-content-center">
          <Col md={6} className="p-5 justify-text">
            <h1 className="mb-4"><strong>FLEXIBLE SOLUTIONS</strong></h1>
            <p style={{ fontSize: '20px' }}>Our company provides customized logistics solutions tailored to each client's specific shipping requirements. This includes flexible transportation options, route optimization, budget-focused freight planning, specialized cargo handling, and time-sensitive delivery solutions.</p>
          </Col>
          <Col md={6} className="p-5 justify-text">
            <Image src={W5} alt="Solutions" width="100%" />
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="d-flex justify-content-center">
          <Col md={6} className="p-5 justify-text">
            <Image src={W6} alt="Communication" width="100%" />
          </Col>
          <Col md={6} className="p-5 justify-text">
            <h1 className="mb-4"><strong>TRANSPARENT COMMUNICATION</strong></h1>
            <p style={{ fontSize: '20px' }}>We maintain open and transparent communication with our clients throughout the entire shipping process. From booking to final delivery, we provide regular updates, shipment tracking, and proactive notifications to ensure full visibility at every stage.</p>
          </Col>
        </Row>
      </Container>

      <Container className="mb-5">
        <Row className="d-flex justify-content-center">
          <Col md={6} className="p-5 justify-text">
            <h1 className="mb-4"><strong>PROFESSIONAL APPROACH</strong></h1>
            <p style={{ fontSize: '20px' }}>We have implemented robust systems and streamlined processes to monitor all active shipments, manage documentation, and ensure timely follow-ups at every stage of transit. Our structured operational framework enables us to maintain accuracy, efficiency, and complete control over every consignment.</p>
          </Col>
          <Col md={6} className="p-5 justify-text">
            <Image src={W7} alt="Approach" width="100%" />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Industries